// @ts-nocheck
import type { UserTagServer } from '@/types/userTags'

export const normalizeUserTags = (data: UserTagServer[]) => {
  return data
    .map((tag) => {
      const campaign = tag?.offers?.[0]
      if (campaign) {
        const trafficSources = campaign.traffic_sources_costs
        if (trafficSources.length) {
          trafficSources.map((el) => {
            el.type = el.cpa ? 'CPA' : 'CPC'
            if (el.cpc) {
              el.cpc = Number((Number(el.cpc).toFixed(0) / 100).toFixed(2))
            }
            if (el.invoice_cpc) {
              el.invoice_cpc = Number((Number(el.invoice_cpc).toFixed(0) / 100).toFixed(2))
            }
            if (el.cpa) {
              el.cpa = Number((Number(el.cpa).toFixed(2) * 100).toFixed(0))
            }
            if (el.invoice_cpa) {
              el.invoice_cpa = Number((Number(el.invoice_cpa).toFixed(2) * 100).toFixed(0))
            }
          })
        }
        delete campaign.traffic_sources_costs
        campaign.trafficSources = trafficSources
      }
      return {
        id: tag.id,
        name: tag.name,
        campaign: campaign,
        usersCount: tag.users_count,
        totalFollowers: tag.users_count,
      }
    })
    .sort((tagA, tagB) => tagA.name.localeCompare(tagB.name))
}
